/**
 * Demo time-series for assessment trend charts (replace with API / resident history).
 */

export const FACILITY_TREND_DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const SIX_MONTH_LABELS = ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function facilitySeed(facilityKey) {
  return String(facilityKey || 'all')
    .split('')
    .reduce((a, c) => a + c.charCodeAt(0), 0);
}

/**
 * @param {string | number} facilityKey
 * @returns {{ assessmentsCompleted: number[], overdueAssessments: number[], labels: string[] }}
 */
export function getFacilityAssessmentTrendSeries(facilityKey = 'all') {
  const seed = facilitySeed(facilityKey);
  const assessmentsCompleted = Array.from({ length: 7 }, (_, i) => {
    const base = 14 + (seed % 5);
    const wobble = Math.round(Math.sin((i + seed * 0.02) * 0.85) * 4);
    return Math.max(6, Math.min(32, base + wobble + i));
  });
  const overdueAssessments = Array.from({ length: 7 }, (_, i) => {
    const base = 4 + (seed % 3);
    const wobble = Math.round(Math.cos((i + seed * 0.03) * 1.1) * 2);
    return Math.max(0, Math.min(14, base + wobble - Math.floor(i / 3)));
  });
  return {
    assessmentsCompleted,
    overdueAssessments,
    labels: [...FACILITY_TREND_DAY_LABELS],
  };
}

/**
 * @param {string | number} residentId
 * @returns {Record<string, number[] | string[] | null>}
 */
export function getResidentAssessmentTrendSeries(residentId) {
  const id = Number(residentId);
  const base = {
    labels: [...SIX_MONTH_LABELS],
    cognitiveMmse: null,
    depressionGds: null,
    delirium4at: null,
    updrs: null,
    kidneyEgfr: null,
    prostateScore: null,
    rheumatoidDas: null,
  };

  if (id === 1) {
    return {
      ...base,
      cognitiveMmse: [24, 23, 22, 21, 19, 18],
      depressionGds: [4, 5, 5, 6, 7, 8],
      delirium4at: [1, 1, 2, 2, 3, 3],
    };
  }
  if (id === 2) {
    return {
      ...base,
      updrs: [38, 40, 41, 42, 44, 45],
    };
  }
  if (id === 3) {
    return {
      ...base,
      kidneyEgfr: [72, 70, 69, 68, 66, 65],
    };
  }
  if (id === 4) {
    return {
      ...base,
      prostateScore: [2, 2, 2, 2, 2, 2],
    };
  }
  if (id === 5) {
    return {
      ...base,
      rheumatoidDas: [2.8, 2.9, 3.0, 3.1, 3.15, 3.2],
    };
  }

  return {
    ...base,
    cognitiveMmse: [26, 25, 25, 24, 24, 23],
  };
}
